import { ShieldCheck, MapPin, BadgeCheck, FileSignature, HeadphonesIcon, Lock } from "lucide-react";

const SECURITY_IMG =
    "https://images.unsplash.com/photo-1604357209793-fca5dca89f97?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxncHMlMjBtYXAlMjBwaG9uZXxlbnwwfHx8fDE3ODAzMDQ2MjV8MA&ixlib=rb-4.1.0&q=85";

const FEATURES = [
    {
        icon: ShieldCheck,
        title: "Assurance tous risques",
        desc: "Chaque véhicule est couvert pendant tout le trajet, sans franchise cachée.",
    },
    {
        icon: BadgeCheck,
        title: "Convoyeurs certifiés",
        desc: "Permis vérifié, expérience contrôlée, casier judiciaire à jour.",
    },
    {
        icon: FileSignature,
        title: "État des lieux digital",
        desc: "Photos horodatées au départ et à l'arrivée, contrat signé électroniquement.",
    },
    {
        icon: HeadphonesIcon,
        title: "Support 7j/7",
        desc: "Une équipe humaine joignable à tout moment en cas d'imprévu.",
    },
    {
        icon: Lock,
        title: "Paiement sécurisé",
        desc: "Vos paiements sont protégés et libérés uniquement après livraison.",
    },
];

export default function TrustSafety() {
    return (
        <section
            id="trust-safety"
            data-testid="trust-safety"
            className="section-y bg-ink text-white relative overflow-hidden"
        >
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(31,111,240,0.2),transparent_50%)]" />

            <div className="container-x relative">
                <div className="grid lg:grid-cols-12 gap-10 mb-16">
                    <div className="lg:col-span-7">
                        <p className="text-xs uppercase tracking-[0.2em] text-signal font-bold mb-4">
                            — Sécurité & Confiance
                        </p>
                        <h2 className="font-display font-black tracking-tighter text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.95] text-balance">
                            Vos véhicules méritent
                            <br />
                            <span className="text-signal">
                                le plus haut niveau
                            </span>{" "}
                            de soin.
                        </h2>
                    </div>
                    <div className="lg:col-span-4 lg:col-start-9 flex items-end">
                        <p className="text-base text-white/60 leading-relaxed">
                            Carvaelis applique des protocoles stricts à
                            chaque étape du convoyage. Notre mission :
                            transformer la confiance en standard.
                        </p>
                    </div>
                </div>

                {/* Bento grid */}
                <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-4">
                    {/* Big feature card with image */}
                    <div
                        data-testid="trust-feature-gps"
                        className="md:col-span-3 lg:col-span-2 lg:row-span-2 relative bg-white text-ink overflow-hidden group min-h-[400px]"
                    >
                        <img
                            src={SECURITY_IMG}
                            alt="Suivi GPS en temps réel"
                            className="absolute inset-0 w-full h-full object-cover opacity-90 group-hover:scale-105 transition-transform duration-700"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-white via-white/70 to-transparent" />
                        <div className="relative h-full flex flex-col justify-end p-8 lg:p-10">
                            <div className="inline-flex items-center gap-2 bg-ink text-white px-3 py-1.5 text-xs font-bold uppercase tracking-wider w-fit mb-4">
                                <MapPin className="w-3.5 h-3.5" />
                                Fonctionnalité phare
                            </div>
                            <h3 className="font-display font-black text-3xl sm:text-4xl tracking-tighter mb-3">
                                Suivi GPS
                                <br />
                                en temps réel.
                            </h3>
                            <p className="text-slate-600 max-w-md">
                                Visualisez la position exacte de votre
                                véhicule à chaque instant, directement
                                depuis votre téléphone.
                            </p>
                        </div>
                    </div>

                    {FEATURES.map((f, i) => {
                        const Icon = f.icon;
                        return (
                            <div
                                key={i}
                                data-testid={`trust-feature-${i}`}
                                className="bg-white/[0.04] border border-white/10 p-7 hover:bg-white/[0.08] hover:border-signal/40 transition-all duration-300 flex flex-col"
                            >
                                <Icon
                                    className="w-7 h-7 text-signal mb-6"
                                    strokeWidth={1.5}
                                />
                                <h3 className="font-display font-bold text-xl text-white mb-2">
                                    {f.title}
                                </h3>
                                <p className="text-sm text-white/60 leading-relaxed">
                                    {f.desc}
                                </p>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
